<p *ngIf="!isLoaded"><em>Cargando...</em></p>
<div *ngIf="isLoaded">
  <div *ngFor="let separador of lstInfoSeparador | async" class="container-fluid">
    <div id="pnlInformativo">
      <div class="dvGral row">
        <span class="lblTituloPnl" >{{separador.strInfoExpediente}}</span>
      </div>
    </div>
    <div class="row pnlGroupingGral">
      <div class="col-md-6">
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Solicitud #</span>
          </div>
          <div class="col">
            <span>{{separador.strNumSolicitud}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Estado Carpeta</span>
          </div>
          <div class="col">
            <span>{{separador.strEstSeparador}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Fecha Apertura</span>
          </div>
          <div class="col">
            <span>{{separador.strFchApertura}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Regional</span>
          </div>
          <div class="col">
            <span>{{separador.strRegional}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Nro. Sucursal</span>
          </div>
          <div class="col">
            <span>{{separador.strNumSucursal}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Nombre Asesor</span>
          </div>
          <div class="col">
            <span>{{separador.strNombreAsesor}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Sucursal Actual</span>
          </div>
          <div class="col">
            <span>{{separador.strSucurFusionadaA}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Producto</span>
          </div>
          <div class="col">
            <span>{{separador.strProducto}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Estado del Crédito</span>
          </div>
          <div class="col">
            <span>{{separador.strEstCredito}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Fecha Cierre</span>
          </div>
          <div class="col">
            <span>{{separador.strFchCierre}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Nombre Director</span>
          </div>
          <div class="col">
            <span>{{separador.strDirector}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Sucursal Inicial</span>
          </div>
          <div class="col">
            <span>{{separador.strNombreSucursal}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col dvEtiLabel">
            <span>Número del Crédito</span>
          </div>
          <div class="col">
            <span>{{separador.strNumCredito}}</span>
          </div>
        </div>
        <div class="row">
          <div class="dvEtiLabel">
            <span></span>
          </div>
          <div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
